"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.myEmployeeReducer = exports.useMyEmployeeReducer = exports.initialMyEmployeeState = void 0;
const react_1 = require("react");
const store_1 = require("core/store");
const useCreateOrUpdateItems_1 = require("src/modules/documents/hr/assign-submissions/store/useCreateOrUpdateItems");
const initialMyEmployeeValue = {
    IsAuthorizedAccount: true,
    startDate: '',
    endDate: '',
    salaryAmount: [],
    workInfo: useCreateOrUpdateItems_1.initialWorkInfoV2,
    fullName: '',
    email: '',
    mobileNumber: '',
    positions: '',
    structuralUnit: '',
    minSalaryAmount: null,
    maxSalaryAmount: null,
    legalAddress: null,
    actualAddress: null,
    identityNumber: '',
    birthDate: null
};
exports.initialMyEmployeeState = {
    data: initialMyEmployeeValue,
    errors: null,
    status: null,
    meta: store_1.initialMeta,
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isLoading: false
};
const useMyEmployeeReducer = () => {
    return (0, react_1.useReducer)(exports.myEmployeeReducer, exports.initialMyEmployeeState);
};
exports.useMyEmployeeReducer = useMyEmployeeReducer;
const myEmployeeReducer = (state, action) => {
    switch (action.type) {
        case 'SEND_MY_EMPLOYEE_REQUEST':
            return {
                ...state,
                errors: null,
                isFetching: true,
                isLoading: true
            };
        case 'DONE_MY_EMPLOYEE_REQUEST':
            return {
                ...state,
                data: action.payload.data || state.data,
                errors: action.payload.errors,
                status: action.payload.status,
                isFetching: false,
                isLoading: state.isCreating || state.isUpdating
            };
        case 'REMOVE_ERROR':
            return {
                ...state,
                errors: state.errors ? state.errors.filter((_el, index) => action.payload !== index) : state.errors
            };
        default:
            return state;
    }
};
exports.myEmployeeReducer = myEmployeeReducer;
